// Text constants for QuotesFallbackView component
import React from 'react';

const fallbackViewTexts = {

  cardTitle: (
    <>
      Plan Your Next Job With Quotes,
      <br />
      the collaborative planning tool.
    </>
  ),
  cardTitleMobile: 'Plan Your Next Job With Quotes, the collaborative planning tool.',
  learnMoreButton: 'Learn More',
  benefits: [
    'Save Time Sourcing Jobs',
    'Lock in Pricing for 7 Days',
    'Share Quotes with Customers'
  ],
  imageAlt: 'Placeholder image',
  learnMoreText: 'Learn More',
  imageUrl: 'https://dam.thdstatic.com/content/production/q7k5j90tEwVD1kPkixSQQQ/'
  + 'OkRd7qOTw_7UpErTtyrMew/Original%20file/WF-6260106-AccountQuotes-Hero.jpg',
};

export default fallbackViewTexts;
